/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { LIVECHAT_PARTICIPANT_TYPES } from '../../../constants/liveChat';
import is from '../../is';

/**
 * Format the data needed to trigger an automation in live-chat
 *
 * @param {Object} conversation The conversation to extract information from
 * @param {Object} customInputForm The custom form data set by the user before triggering the action
 * @returns {Object} Returns the formatted body data
 */
export default function createAutomationBody(conversation, customInputForm) {
  let data;
  if (conversation) {
    const endUser = conversation.livechatParticipants.find(participant => participant.participantType === LIVECHAT_PARTICIPANT_TYPES.ENDUSER);
    const agent = conversation.livechatParticipants.find(participant => participant.participantType === LIVECHAT_PARTICIPANT_TYPES.AGENT);

    data = {
      platformSessionId: conversation.platformSessionId,
      livechatEndUser: {
        platformUserId: endUser.platformUserId,
        email: endUser.email,
        fullName: endUser.fullName
      },
      livechatAgent: {
        platformUserId: agent.platformUserId,
        email: agent.email,
        fullName: agent.fullName
      },
      conversationId: conversation.id,
      trigger: 'manual'
    };

    if (is.object(customInputForm)) {
      data.customInputForm = customInputForm;
    }
  }

  return data;
}
